import React from "react";
// import "./AdminUserList.css";
import { useDispatch } from "react-redux";
import { changeCurrentConfigurationMenu } from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import ButtonWithoutIcon from "../../components/StyledComp/ButtonWithoutIcon";
// import AdminUserCreation from "./AdminUserCreation";

const ConfigurationHeader: React.FC = () => {
  const dispatch = useDispatch();

  const AdminUserMenu = () => {
    console.log("AdminUserMenu");
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.adminUserConfiguration)
    );
  };

  // const AdminUserCreation = () => {
  //   console.log("AdminUserCreation");
  //   dispatch(
  //     changeCurrentConfigurationMenu(
  //       screenConfig.adminUserCreationConfiguration
  //     )
  //   );
  // };

  // const MemberTypeMenu = () => {
  //   console.log("MemberTypeMenu");
  //   dispatch(
  //     changeCurrentConfigurationMenu(screenConfig.memberTypeConfiguration)
  //   );
  // };

  const MemberCodeMenu = () => {
    console.log("MemberCodeMenu");
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.memberCodeConfiguration)
    );
  };

  const MemberTagMenu = () => {
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.memberTagConfiguration)
    );
  };

  const MemberSectionMenu = () => {
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.memberSectionConfiguration)
    );
  };

  const FirmManagementMenu = () => {
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.FirmManagementConfiguration)
    );
  };

  const LocationMenu = () => {
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.LocationConfiguration)
    );
  };
  const CostMenu = () => {
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.CostConfiguration)
    );
  };

  const HelpVideosMenu = () => {
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.HelpVideosConfiguration)
    );
  };

  return (
    <div className="dashboard-menu-wrapper-left d-none d-lg-flex w-100">
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="User List"
          onClick={AdminUserMenu}
        />
      </div>
      {/* <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          icon={<></>}
          buttontext="Add New User"
          onClick={AdminUserCreation}
        />
      </div> */}
      {/* <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Member Type"
          onClick={MemberTypeMenu}
        />
      </div> */}
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Member Code"
          onClick={MemberCodeMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Member Section"
          onClick={MemberSectionMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Member Tag"
          onClick={MemberTagMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Firm Management"
          onClick={FirmManagementMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Location"
          onClick={LocationMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Cost"
          onClick={CostMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Help Videos"
          onClick={HelpVideosMenu}
        />
      </div>
    </div>
  );
};

export default ConfigurationHeader;
